import { render, staticRenderFns } from "./GiftBox.vue?vue&type=template&id=7a6d23d2&scoped=true&"
import script from "./GiftBox.vue?vue&type=script&lang=js&"
export * from "./GiftBox.vue?vue&type=script&lang=js&"
import style0 from "./GiftBox.vue?vue&type=style&index=0&id=7a6d23d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6d23d2",
  null
  
)

export default component.exports